import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    question: "¿Qué recibo exactamente al ingresar?",
    answer: "Al ingresar recibes acceso al programa educativo provisto por MINED, que incluye contenido estructurado por módulos, clases grabadas disponibles 24/7, herramientas complementarias de apoyo, recursos descargables, y acceso al entorno de comunidad (según la modalidad elegida)."
  },
  {
    question: "¿Las clases son grabadas o en vivo?",
    answer: "El contenido principal son clases grabadas que puedes ver a tu propio ritmo, cuando quieras y cuantas veces necesites. Además, según tu modalidad de acceso, puedes participar en espacios de comunidad y consultas dentro del programa."
  },
  {
    question: "¿Durante cuánto tiempo tengo acceso?",
   answer: "El tiempo de acceso depende de la modalidad que elijas: 90 días, 180 días o 360 días. Durante ese período tendrás acceso al contenido, herramientas y recursos incluidos según la modalidad seleccionada."
  },
  {
    question: "¿Qué papel cumplen las herramientas?",
    answer: "Las herramientas complementan tu aprendizaje con recursos prácticos: apoyo para validación de productos, análisis de mercado, organización de operaciones y seguimiento. Están diseñadas para que apliques lo que aprendes con más criterio y estructura."
  },
  {
    question: "¿Hay comunidad o acompañamiento?",
    answer: "Sí, el entorno de comunidad forma parte de la propuesta educativa. Es un espacio donde puedes hacer consultas, compartir avances y conectar con otras personas en procesos similares. Además, DSA ofrece orientación comercial durante tu proceso de evaluación."
  },
  {
    question: "¿Esto es para alguien que recién empieza?",
    answer: "Sí, la ruta está diseñada para partir desde cero. No necesitas experiencia previa en ecommerce. Los módulos están organizados de forma progresiva, ayudándote a desarrollar criterio desde los fundamentos hasta la operación."
  },
  {
    question: "¿DSA es quien dicta el programa?",
    answer: "No. DSA no es el proveedor educativo del programa. DSA actúa como embajador y canal de orientación, precalificación y acompañamiento comercial. El programa es provisto por MINED."
  },
  {
    question: "¿Quién es el proveedor educativo?",
    answer: "El proveedor educativo del programa referido en esta página es MINED. MINED es quien desarrolla, provee y actualiza el contenido educativo, las herramientas y el entorno de comunidad."
  },
  {
    question: "¿Qué hace exactamente DSA en este proceso?",
    answer: "DSA te ayuda a entender la propuesta, resolver dudas iniciales, evaluar encaje y acompañar el proceso comercial de ingreso. La prestación educativa del programa corresponde a MINED."
  },
  {
    question: "¿Cómo funciona el proceso de evaluación?",
    answer: "El proceso es simple: completa el formulario de contacto, un asesor de DSA se comunicará contigo para orientarte, resolver dudas y ayudarte a evaluar si esta propuesta encaja contigo. No hay presión ni compromiso. Es un proceso de evaluación informada."
  },
];

export default function FAQSection() {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="py-20 md:py-28 bg-white"
    >
      <div className="max-w-4xl mx-auto px-6 md:px-12">
        {/* Section Header */}
        <div className="text-center max-w-2xl mx-auto mb-16">
          <span className="text-sm uppercase tracking-[0.25em] font-semibold text-[#0F3D56] mb-4 block">
            Preguntas frecuentes
          </span>
          <h2
            className="text-3xl md:text-5xl font-semibold text-[#111827] mb-6"
            style={{ fontFamily: "'Cormorant Garamond', serif" }}
          >
            Resuelve tus dudas
          </h2>
          <p className="text-base text-gray-600">
            Respuestas claras a las preguntas más comunes sobre la propuesta.
          </p>
        </div>

        {/* FAQ Accordion */}
        <Accordion type="single" collapsible className="space-y-4">
          {faqs.map((faq, index) => (
            <AccordionItem
              key={index}
              value={`faq-${index}`}
              data-testid={`faq-item-${index}`}
              className="border border-gray-200 bg-gray-50/50 px-6 data-[state=open]:bg-white data-[state=open]:border-[#0F3D56]/20 transition-all"
            >
              <AccordionTrigger
                data-testid={`faq-trigger-${index}`}
                className="text-left text-base font-semibold text-[#111827] hover:text-[#0F3D56] py-5 hover:no-underline"
              >
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-sm text-gray-600 leading-relaxed pb-5">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>

        {/* Bottom Note */}
        <div className="mt-12 text-center">
          <p className="text-sm text-gray-500">
            ¿Tienes más preguntas? Completa el formulario y un asesor de DSA te contactará.
          </p>
        </div>
      </div>
    </section>
  );
}
